module.exports = __webpack_public_path__ + "img/negative_results.fed6e76d.png";